/** Hosted Stage — build with `--configuration=stage` (see package.json / angular.json). */
const gtwHost = 'https://stage.gtw.pwc.com';

export const environment = {
  production: true,
  base_url: `${gtwHost}/gtw`,
  admin_api_url: `${gtwHost}/admin`,
  custom_api_url: `${gtwHost}/custom`,
  batch_api_url: `${gtwHost}/batch`,
  efile_api_url: `${gtwHost}/gtw-efile-api`,
  pdf_engine_api_url: `${gtwHost}/pdf-engine`,
  bulk_pdf_engine_api_url: `${gtwHost}/bulk-pdf-engine`,
  scheduler_api_url: `${gtwHost}/scheduler`,
  api: `${gtwHost}/gtw`
};
